import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  effect,
  input,
  output,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Guid, once } from '@web/utils';
import { Observable } from 'rxjs';
import { AdminShippingMethodFormData } from '../../models/admin-shipping-method-form-data';
import { HttpErrorService } from '@web/common';
import {
  AlertsComponent,
  AlertsService,
  SpinnerFilledComponent,
} from '@web/shared/ui';
import { AdminShippingMethodDataSourceService } from '../../services/admin-shipping-method-data-source.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AdminShippingMethodFormComponent } from '../admin-shipping-method-form/admin-shipping-method-form.component';

@Component({
  selector: 'app-admin-shipping-method-edit',
  imports: [
    CommonModule,
    AdminShippingMethodFormComponent,
    AlertsComponent,
    SpinnerFilledComponent,
  ],
  templateUrl: './admin-shipping-method-edit.component.html',
  styleUrl: './admin-shipping-method-edit.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AlertsService],
})
export class AdminShippingMethodEditComponent {
  /* prettier-ignore */
  private readonly shippingMethodDataSource = inject(AdminShippingMethodDataSourceService);
  private readonly httpError = inject(HttpErrorService);
  private readonly alerts = inject(AlertsService);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  public readonly id = input.required<Guid>();
  public readonly submitSuccessEvent = output();

  protected data$!: Observable<AdminShippingMethodFormData>;

  public constructor() {
    effect(() => this.configureDataSource());
  }

  public handleSubmitSuccessEvent(data: AdminShippingMethodFormData): void {
    this.shippingMethodDataSource
      .updateByFormData(this.id(), data)
      .pipe(once())
      .subscribe({
        next: () => this.notifySubmitSuccessEvent(),
        error: (response) => this.showFailureAlertByResponse(response),
      });
  }

  private configureDataSource(): void {
    this.data$ = this.shippingMethodDataSource.fetchDetailsFormById(this.id());

    this.changeDetectorRef.detectChanges();
  }

  private notifySubmitSuccessEvent(): void {
    this.submitSuccessEvent.emit();
  }

  private showFailureAlertByResponse(response: HttpErrorResponse): void {
    this.alerts.showMultiple((builder) =>
      this.httpError
        .extract(response)
        .messages()
        .map((message) => builder.buildFailure(message)),
    );
  }
}
